import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  connect() {
    if (this.shouldLoadData && this.dataURL) {
      this.element.innerHTML = App.spinner();
      xhrRequest(this.dataURL, 'get')
        .then(({ data }) => this.element.parentNode.replaceChild(document.createElementFromString(data, 'tr'), this.element));
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get shouldLoadData() {
    return this.data.has('load-data') && ['1', true, 'true'].indexOf(this.data.get('load-data')) > -1;
  }

  get dataURL() {
    return this.data.get('data-url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/calendar/day-availability-controller.js